// File: frontend/src/views/private/admin/DMS.js

import React from 'react';
import AdminPageTemplate from '../../../components/layout/AdminPageTemplate';
import { Database } from 'lucide-react';

const DMS = () => {
  return (
    <AdminPageTemplate
      title="Document Management System"
      subtitle="Organize, store, and manage all system documents"
      icon={Database}
      showComingSoon={true}
    />
  );
};

export default DMS;